import React, { useRef } from 'react';
import * as cls from './home-insights.module.css';
import { Section } from '../../../../ui/components/section';
import { Typography } from '../../../../ui/components/typography';
import { IMG_PATH } from '../../../../constants';
import { ListToggle } from '../../../../ui/layouts/list-toggle/list-toggle';

const items = [
  {
    title: 'Appliance-level bill breakdowns',
    text: (
      <Typography>to explain high bills and prioritise actions.</Typography>
    ),
  },

  {
    title: 'Automated insights and anomaly signals',
    text: (
      <Typography>to identify unusual or inefficient consumption.</Typography>
    ),
  },

  {
    title: 'Reports and recommendations',
    text: (
      <Typography>
        to support engagement and programme participation.
      </Typography>
    ),
  },

  {
    title: 'Monitoring and safety signals (where enabled)',
    text: (
      <Typography>
        unusual-use notifications and optional wellbeing indicators.
      </Typography>
    ),
  },
];

const utilitiesItems = [
  {
    title: 'Smart-meter compatible',
    text: (
      <Typography>
        deliver appliance insights using interval data, with APIs for
        integration into apps, portals, and analytics stacks.
      </Typography>
    ),
  },
  {
    title: 'High-resolution options',
    text: (
      <Typography>
        support near-real-time engagement where higher-frequency data is
        available (e.g., compatible devices or approved data pathways).
      </Typography>
    ),
  },
  {
    title: 'Hardware pathway (optional)',
    text: (
      <Typography>
        add a compact sensor for ultra-high-resolution analytics where required
        (e.g., pilots, specific cohorts, or markets without suitable data
        feeds).
      </Typography>
    ),
  },
];

export const HomeInsights = () => {
  const animatedItems = useRef(new Set([0, 1, 2, 3]));
  return (
    <>
      <Section classNameRoot={cls.section}>
        <Typography as="h1" tag="h2">
          Insights That Drive Outcomes
        </Typography>

        <div className={cls.wrapper}>
          <div>
            <ListToggle
              animatedItems={animatedItems.current}
              classNameActive={cls.itemActive}
              classNameAnimated={cls.animated}
              classNameHidden={cls.hiddenLeft}
              iconCheck
              items={items}
            />
          </div>
          <img
            src={`${IMG_PATH}/our-technology/energy-intelligence/home-insights.png`}
            alt="Utility-facing insight cards (e.g., High-bill explanation, EV charging pattern, Heat-pump performance, Anomaly alerts)"
          />
          <img
            className={cls.imgMobile}
            src={`${IMG_PATH}/our-technology/energy-intelligence/home-insights-mobile.png`}
            alt="Utility-facing insight cards (e.g., High-bill explanation, EV charging pattern, Heat-pump performance, Anomaly alerts)"
          />
        </div>
      </Section>

      <Section backgroundContrast classNameRoot={cls.section}>
        <Typography as="h1" tag="h2">
          For Utilities & Energy Providers
        </Typography>

        <div className={cls.wrapper}>
          <img
            src={`${IMG_PATH}/our-technology/energy-intelligence/utilities-and-energy-providers.png`}
            alt="B2B card set: EV detection, heat-pump insights, API export."
          />
          <img
            className={cls.imgMobile}
            src={`${IMG_PATH}/our-technology/energy-intelligence/utilities-and-energy-providers-mobile.png`}
            alt="B2B card set: EV detection, heat-pump insights, API export."
          />

          <div>
            <Typography className={cls.listCaption}>
              <strong>Deploy fast. Engage deeply. Integrate cleanly.</strong>
            </Typography>
            <div>
              <ListToggle
                animatedItems={animatedItems.current}
                classNameActive={cls.itemActive}
                classNameAnimated={cls.animated}
                classNameHidden={cls.hiddenLeft}
                iconCheck
                items={utilitiesItems}
              />
            </div>
          </div>
        </div>
      </Section>
    </>
  );
};
